module.exports = __webpack_public_path__ + "static/media/serviceimg_04.7a5ba01c.svg";